import { findDOMNode } from 'react-dom';


export class RightSideBarModule {
    private wrapper;

    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    public get name() {
        return 'base';
    }

    /**
     * for specific requirements, the extra parameters are required.
     * @param {parameters} param
     */
    show(param) {
        this.showWrapper();
    }

    hide() {
        this.hideWrapper();
    }

    showWrapper() {
        this.wrapper?.show();
    }

    hideWrapper() {
        this.wrapper?.hide();
    }

    wrapperWillShow() {
    }

    wrapperDidHide() {
    }

    public get DOMNode() {
        // eslint-disable-next-line react/no-find-dom-node
        return this.wrapper ? findDOMNode(this.wrapper) : null;
    }
}
